document.addEventListener('click',function(e){
  var b=e.target.closest('[data-bl-menu]');
  if(b){
    var n=document.querySelector('[data-bl-nav]');
    if(n){
      n.hidden=!n.hidden;
      b.setAttribute('aria-expanded',n.hidden?'false':'true');
      b.classList.toggle('is-open',!n.hidden);
    }
    return;
  }

  var pill=e.target.closest('[data-bl-pill]');
  if(pill){
    var box=pill.closest('[data-bl-subject]');
    box.querySelectorAll('[data-bl-pill]').forEach(function(x){x.setAttribute('aria-pressed','false');});
    pill.setAttribute('aria-pressed','true');
    var hid=box.parentNode.querySelector('[data-bl-subject-value]');
    if(hid)hid.value=pill.dataset.blPill;
    return;
  }

  var g=e.target.closest('[data-bl-gal]');
  if(g){
    var root=g.closest('.bl-gal'),track=root.querySelector('.bl-gal__t'),
        dots=root.querySelectorAll('.bl-gal__d button'),
        n=track.children.length,
        i=parseInt(root.dataset.i||'0',10),
        d=g.dataset.blGal;
    i = d==='prev' ? (i-1+n)%n : d==='next' ? (i+1)%n : parseInt(d,10);
    root.dataset.i=i;
    track.style.transform='translateX('+(i*-100)+'%)';
    dots.forEach(function(x,k){x.setAttribute('aria-current',k===i?'true':'false');});
    return;
  }

  var c=e.target.closest('[data-bl-opt]');
  if(c&&!c.disabled){
    var box=c.closest('[data-bl-optbox]');
    box.querySelectorAll('[data-bl-opt]').forEach(function(x){x.setAttribute('aria-checked','false');});
    c.setAttribute('aria-checked','true');
    var lab=box.querySelector('[data-bl-optval]');
    if(lab)lab.textContent=c.dataset.blOpt;
    var form=c.closest('form');
    if(form){
      var picks=[];
      form.querySelectorAll('[data-bl-optbox]').forEach(function(bx){
        var on=bx.querySelector('[data-bl-opt][aria-checked="true"]');
        if(on)picks.push(on.dataset.blOpt);
      });
      var data=form.querySelector('[data-bl-variants]');
      if(data){
        var vs=JSON.parse(data.textContent),hit=null;
        for(var k=0;k<vs.length;k++){
          var ok=true;
          for(var j=0;j<picks.length;j++){if(vs[k].options[j]!==picks[j]){ok=false;break;}}
          if(ok){hit=vs[k];break;}
        }
        var id=form.querySelector('[name="id"]'),
            now=form.querySelector('[data-bl-now]'),
            was=form.querySelector('[data-bl-was]'),
            btn=form.querySelector('[data-bl-add]');
        if(hit){
          if(id)id.value=hit.id;
          if(now)now.textContent=hit.price;
          if(was)was.textContent=hit.compare||'';
          if(btn){btn.disabled=!hit.available;btn.textContent=hit.available?(btn.dataset.blAdd||'Ajouter au panier'):'Épuisé';}
        }
      }
    }
    return;
  }

  var s=e.target.closest('[data-bl-step]');
  if(s){
    var wrap=s.closest('[data-bl-evo]');
    wrap.querySelectorAll('[data-bl-step]').forEach(function(x){x.setAttribute('aria-checked','false');});
    s.setAttribute('aria-checked','true');
    var all=wrap.querySelectorAll('[data-bl-step]'),
        idx=Array.prototype.indexOf.call(all,s)+1,
        bar=wrap.querySelector('.bl-evo__bar i'),
        num=wrap.querySelector('[data-bl-stepn]'),
        txt=wrap.querySelector('[data-bl-steptxt]');
    if(bar)bar.style.width=(idx/all.length*100)+'%';
    if(num)num.textContent=idx+' / '+all.length;
    if(txt&&s.dataset.blStep)txt.innerHTML=s.dataset.blStep;
  }
});

/* --------- lignes de collection : defilement doux vers la droite --------- */
(function(){
  'use strict';
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion:reduce)').matches;

  function initAuto(rail){
    if(rail.dataset.blAutoOn)return;
    rail.dataset.blAutoOn='1';

    var items=Array.prototype.slice.call(rail.children);
    if(!items.length)return;

    // duplication pour une boucle sans couture
    items.forEach(function(el){
      var c=el.cloneNode(true);
      c.setAttribute('aria-hidden','true');
      c.querySelectorAll('a,button,input').forEach(function(x){x.setAttribute('tabindex','-1');});
      rail.appendChild(c);
    });

    var half=rail.scrollWidth/2;
    rail._half=half;
    var secs=parseFloat(rail.dataset.blSpeed||'26');
    var pxPerMs=half/(secs*1000);
    var paused=false,last=null,raf=null;

    function frame(t){
      if(last===null)last=t;
      var dt=t-last;last=t;
      if(!paused&&!rail._hold){
        rail.scrollLeft+=pxPerMs*dt;
        if(rail.scrollLeft>=half)rail.scrollLeft-=half;
      }
      raf=requestAnimationFrame(frame);
    }

    function start(){if(!raf){last=null;raf=requestAnimationFrame(frame);}}
    function stop(){if(raf){cancelAnimationFrame(raf);raf=null;}}

    rail.addEventListener('mouseenter',function(){paused=true;});
    rail.addEventListener('mouseleave',function(){paused=false;last=null;});
    rail.addEventListener('focusin',function(){paused=true;});
    rail.addEventListener('focusout',function(){paused=false;last=null;});
    rail.addEventListener('touchstart',function(){paused=true;},{passive:true});
    rail.addEventListener('touchend',function(){
      clearTimeout(rail._r);
      rail._r=setTimeout(function(){paused=false;last=null;},2200);
    },{passive:true});
    rail.addEventListener('wheel',function(){
      paused=true;clearTimeout(rail._w);
      rail._w=setTimeout(function(){paused=false;last=null;},2200);
    },{passive:true});

    // glisser a la souris
    var down=false,sx=0,sl=0;
    rail.addEventListener('mousedown',function(ev){
      down=true;sx=ev.pageX;sl=rail.scrollLeft;rail.classList.add('is-drag');
    });
    window.addEventListener('mouseup',function(){down=false;rail.classList.remove('is-drag');});
    window.addEventListener('mousemove',function(ev){
      if(!down)return;
      ev.preventDefault();
      rail.scrollLeft=sl-(ev.pageX-sx);
      if(rail.scrollLeft>=half)rail.scrollLeft-=half;
      if(rail.scrollLeft<0)rail.scrollLeft+=half;
    });

    // ne tourne que lorsque la section est visible
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(entries){
        entries.forEach(function(en){en.isIntersecting?start():stop();});
      },{threshold:0.05}).observe(rail);
    }else start();
  }

  function initReveal(){
    if(reduce||!('IntersectionObserver' in window))return;
    var sel='.bl-sec > div, .bl-band, .bl-trust__c, .bl-rev, .bl-ct__card, .bl-ct__img, .bl-note, .bl-gift';
    var obs=new IntersectionObserver(function(entries,o){
      entries.forEach(function(en){
        if(en.isIntersecting){en.target.classList.add('is-in');o.unobserve(en.target);}
      });
    },{threshold:0.08,rootMargin:'0px 0px -6% 0px'});
    document.querySelectorAll(sel).forEach(function(el,i){
      if(el.dataset.blReveal)return;
      el.dataset.blReveal='1';
      el.classList.add('bl-reveal');
      el.style.transitionDelay=(Math.min(i,4)*55)+'ms';
      obs.observe(el);
    });
  }


  function initArrows(){
    document.querySelectorAll('[data-bl-railwrap]').forEach(function(w){
      if(w.dataset.blArrOn)return;w.dataset.blArrOn='1';
      var rail=w.querySelector('.rail');if(!rail)return;
      function step(){var c=rail.children[0];if(!c)return 280;var g=parseFloat(getComputedStyle(rail).columnGap||getComputedStyle(rail).gap)||16;return c.getBoundingClientRect().width+g;}
      function go(dir){
        rail._hold=true;clearTimeout(rail._hT);
        var h=rail._half||0,s=step();
        if(h){
          if(dir<0&&rail.scrollLeft<s+2){rail.style.scrollBehavior='auto';rail.scrollLeft+=h;}
          if(dir>0&&rail.scrollLeft>=h-s){rail.style.scrollBehavior='auto';rail.scrollLeft-=h;}
        }
        rail.scrollBy({left:dir*s,behavior:'smooth'});
        rail._hT=setTimeout(function(){rail._hold=false;},4000);
      }
      var p=w.querySelector('[data-bl-prev]'),n=w.querySelector('[data-bl-next]');
      if(p)p.addEventListener('click',function(){go(-1);});
      if(n)n.addEventListener('click',function(){go(1);});
    });
  }

  function initKids(){
    var b=document.body;if(!b.classList.contains('bl-kids'))return;
    var list=(b.dataset.emoji||'').split(',').map(function(x){return x.trim();}).filter(Boolean);
    var n=parseInt(b.dataset.emojiN||'2',10);if(!list.length||!n)return;
    var spots=[[4,10],[90,14],[8,78],[86,72]],k=0;
    document.querySelectorAll('.bl-sec,.bl-trust,.bl-ct').forEach(function(s){
      if(s.dataset.kidsOn)return;s.dataset.kidsOn='1';
      if(getComputedStyle(s).position==='static')s.style.position='relative';
      for(var i=0;i<n;i++){
        var e=document.createElement('span');e.className='bl-float';e.setAttribute('aria-hidden','true');
        e.textContent=list[k%list.length];k++;
        var p=spots[(i+k)%spots.length];
        e.style.left=p[0]+'%';e.style.top=p[1]+'%';
        e.style.animationDelay=(-(k*1.7)%9)+'s';e.style.animationDuration=(7+(k%4))+'s';
        s.appendChild(e);
      }
    });
  }

  function boot(){
    if(!reduce)document.querySelectorAll('[data-bl-auto]').forEach(initAuto);
    initReveal();
    initArrows();
    if(!reduce)initKids();
  }

  if(document.readyState!=='loading')boot();
  else document.addEventListener('DOMContentLoaded',boot);
  document.addEventListener('shopify:section:load',boot);
})();